import clsx from 'clsx';
import React from 'react';

import imgPhone from 'images/pro/Phone.png';
import imgTriangleTop from 'images/pro/TriangleTop.svg';

import useCurrentUser from '../../hooks/useCurrentUser';
import { subscribe_promotion_path, upgrade_subscription_path } from '../../routes';
import {
  DEFAULT_ANNUAL_OFFER_CODE,
  DEFAULT_MONTHLY_OFFER_CODE,
  DEFAULT_PRO_OFFER_CODE,
  DEFAULT_YP_OFFER_CODE,
} from '../../src/constants';

const ProHero = () => {
  const { currentUser } = useCurrentUser();
  const isCurrentUserSubscriber = currentUser?.is_subscriber;
  const isCurrentUserProSubscriber = currentUser?.is_pro_subscriber;

  return (
    <div className="tw-px-16 xs:tw-px-48 tw-my-32 md:tw-mt-72">
      <div className="tw-flex md:tw-max-w-[1024px] tw-mx-auto tw-relative">
        <div className="sm:tw-max-w-[458px] md:tw-max-w-[524px]">
          <p className="tw-font-sans tw-text-overline tw-text-primary-red tw-uppercase tw-m-0">
            {isCurrentUserSubscriber && !isCurrentUserProSubscriber
              ? 'Upgrade now'
              : !isCurrentUserSubscriber && 'Subscribe'}
          </p>
          <h2 className="tw-font-serif md-d:tw-text-[32px] tw-text-headline-lg tw-text-primary-black tw-m-0 tw-mt-16">
            Don{'’'}t read the news.
            <br />
            Make the news.
            <br />
            The Information Pro.
          </h2>
          <p className="tw-text-paragraph tw-font-serif tw-text-black tw-m-0 tw-mt-16">
            The Information Pro is a new service for professionals who need non-public resources to
            excel at their jobs. You{'’'}ll have access to the resources we built for
            ourselves—because we couldn{'’'}t find them anywhere else. Don{'’'}t take a meeting
            without The Information Pro.
          </p>
          {!isCurrentUserProSubscriber && (
            <a
              href={
                isCurrentUserSubscriber
                  ? upgrade_subscription_path()
                  : subscribe_promotion_path({
                      offer: `${DEFAULT_PRO_OFFER_CODE},${DEFAULT_ANNUAL_OFFER_CODE},${DEFAULT_MONTHLY_OFFER_CODE},${DEFAULT_YP_OFFER_CODE}`,
                    })
              }
              className={clsx(
                'tw-text-button-md tw-font-sans !tw-text-white tw-bg-primary-red uppercase',
                'xs:tw-w-[245px] tw-h-40 tw-flex tw-items-center tw-justify-center tw-rounded-r-2 tw-mt-24 md:tw-mt-32',
                'hover:tw-bg-pro-red focus:tw-bg-pro-red tw-transition-colors'
              )}
            >
              {isCurrentUserSubscriber ? 'Upgrade' : 'Get Started'}
            </a>
          )}
        </div>
        <div className="tw-absolute -tw-top-24 md:-tw-top-40 tw-left-[150px] sm:tw-left-auto sm:-tw-right-[100px] tw-mix-blend-multiply tw-w-full xs:tw-w-auto">
          <img
            className="tw-block tw-object-contain tw-object-top tw-w-full"
            src={imgTriangleTop}
            alt=""
          />
        </div>
        <div className="tw-hidden sm:tw-block tw-absolute tw-right-0 -tw-top-24 sm:tw-left-[600px] tw-w-[275px] md:tw-w-[325px]">
          <img
            className="tw-block tw-object-contain tw-object-top tw-w-full"
            src={imgPhone}
            alt=""
          />
        </div>
        <div className="tw-hidden sm:tw-block tw-w-[275px] tw-shrink-0" />
      </div>
    </div>
  );
};

export default ProHero;
